import { Component, computed, OnDestroy, OnInit, Signal } from '@angular/core';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  IrspaDetailedInformationOnTheLetterContentForm
} from './forms/irspa-detailed-information-on-the-letter-content.form';
import { updateParcels } from '../../../../../store/actions/application.actions';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ParcelsCrudComponent } from '../components/parcels/parcels-crud/parcels-crud.component';

export interface IrspaDetailedInformationOnTheLetterContentComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
  parcelsRequired?: boolean;
}

@Component({
  selector: 'app-irspa-detailed-information-on-the-letter-content-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ParcelsCrudComponent
  ],
  providers: [
    IrspaDetailedInformationOnTheLetterContentForm
  ],
  templateUrl: './irspa-detailed-information-on-the-letter-content-section.component.html'
})
export class IrspaDetailedInformationOnTheLetterContentSectionComponent implements OnInit, OnDestroy {

  public stages: string[] = this.route.snapshot.data['stages'];

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public planNameControl: Signal<boolean> = computed(() => {
    const app = this.application();
    switch (app?.service?.url) {
      case '/wniosek-o-sporządzenie-aktu-planowania-przestrzennego': {
        return false;
      }
      default: {
        return true;
      }
    }
  });

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public canAddDetailedInformationControls: Signal<boolean> = computed(() =>
    [
      '/wniosek-o-zmiane-aktu-planowania-przestrzennego',
      '/wniosek-do-projektu-aktu-planowania-przestrzennego',
      '/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego'
    ].includes(this.application()?.service?.url || '')
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: IrspaDetailedInformationOnTheLetterContentForm
  ) {
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }


  public onCancel(): void {
    this.router.navigate([this.cancelUrl], { relativeTo: this.route });
  }

  public ngOnInit(): void {
    if (this.route.snapshot.data['parcelsRequired']) {
      this.form.parcels.setValidators([Validators.minLength(1)]);
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
